import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import TimberTypeFormSelect from "../../../../timber/components/timberType/TimberTypeForm/TimberTypeFormSelect";
import { PrimaryTimberType } from "../../../../timber/types/models/TimberType.ts";

import TimberClassFormSelect from "../../../../timber/components/timberClass/TimberClassForm/TimberClassFormSelect";
import { PrimaryTimberClass } from "../../../../timber/types/models/TimberClass.ts";

import ThicknessClassFormSelect from "../../../../timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect";
import { PrimaryThicknessClass } from "../../../../timber/types/models/ThicknessClass.ts";
import { t, msg } from "@lingui/core/macro"



















export const initialFormStateFn = () => { return {
    
        
        timberTypeId: null,
        
    
        
        classId: null,
        
    
        
        thicknessClassId: null,
        
    
        
        price: "",
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        timberTypeId:
        string()
                .nanoid(msg`Timber Type is required`)
                .min(1, msg`Timber Type is required`),
    
    
        classId:
        string()
                .nanoid(msg`Timber Class is required`)
                .min(1, msg`Timber Class is required`),
    
    
        thicknessClassId:
        string()
                .nanoid(msg`Thickness Class is required`)
                .nullish(),
    
    
        price:
        number()
                     .gt(0).transform((value) => (!value ? null : value))
                    .and(coerce.number(msg`must be a number.`)),
    
};

export const formSchema = object(formObject);

const PriceUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
    
    <TimberTypeFormSelect
        type="select"
        name="timberTypeId"
        label={t`Timber Type`}
        prefix={prefix}
        required={ true }
    />
   
   
   
            
            
   
    
    <TimberClassFormSelect
        type="select"
        name="classId"
        label={t`Timber Class`}
        prefix={prefix}
        required={ true }
    />
   
   
   
            
            
   
    
    <ThicknessClassFormSelect
        type="select"
        name="thicknessClassId"
        label={t`Thickness Class`}
        prefix={prefix}
        required={ false }
    />
   
   
   
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'price' }
       aria-label="price"
       data-testid="price"
       label={t`Price`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
            
        </Container>
    )
}

export default PriceUpdateForm;
